<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
body{
  zoom: 90%;
}
@media(max-width: 1800px) {
  body{
    zoom: 75%;
  }
}
</style>
